<header class="header">
  <div class="container-options">
    <div class="backIcon">
      <img
        (click)="back()"
        src="../../../../../assets/iconos/regresar1.svg"
        alt=""
        class="pointer"
      />
    </div>
    <div class="backIcon">
      <h2 class="textInfo">{{ text }}</h2>
    </div>
    <div class="content-config">
      <mat-icon
        [matBadge]="countNotifications"
        matBadgePosition="before"
        matBadgeColor="accent"
        matBadgeSize="small"
        class="notification-button mrleft pointer"
        data-tour="general.notificaciones"
        (click)="viewNotifications = !viewNotifications"
        >notifications</mat-icon
      >

      <div *ngIf="viewNotifications" class="notificaciones">
        <app-notificaciones
          [notificaciones]="notificaciones"
          [view]="viewNotifications"
          (hidden)="viewNotifications = false"
        ></app-notificaciones>
      </div>

      <div
        class="user_section mrleft pointer"
        [matMenuTriggerFor]="userMenu"
        data-tour="general.usuario"
      >
        <img class="pointer" *ngIf="photo" [src]="photo" />
        <mat-icon *ngIf="!photo" class="color-icon-circle"
          >account_circle</mat-icon
        >
      </div>
      <div class="names mrleft">
        <h3 class="role name cerom">{{ roeleName }}</h3>
        <h3 class="name cerom">{{ name }}</h3>
      </div>

      <mat-menu #userMenu="matMenu" xPosition="before" class="menu-user">
        <a mat-menu-item routerLink="/profile">
          <i class="fa fa-user"></i> Perfil
        </a>
        <button mat-menu-item (click)="doLogout()">
          <i class="fa fa-power-off"></i> Salir
        </button>
      </mat-menu>
    </div>
  </div>
</header>

<div class="create-content">
  <app-alerts-in-process-alert
    [isOpen]="isModalOpen"
    (closeModal)="onAlertModalClose()"
    (openProcessModal)="onOpenProcessModal()"
  >
  </app-alerts-in-process-alert>

  <div *ngIf="isProcessModalOpen">
    <app-alerts-in-process-modal
      [isOpen]="isProcessModalOpen"
      (closeModal)="isProcessModalOpen = false"
      [alert]="alert"
    >
    </app-alerts-in-process-modal>
  </div>
</div>
